"use client";

import { Spinner } from "@/components/ui/spinner";

import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Send, X } from "lucide-react";
import { useAppRouter as useRouter } from "@/lib/navigation";
import type React from 'react';

interface StartFormFooterProps {
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  isSubmitting: boolean;
  processDefinitionId: string;
}

export function StartFormFooter({ 
  onSubmit, 
  isSubmitting,
}: StartFormFooterProps) {
  const router = useRouter();
  
  const handleCancel = () => {
    router.push('/task-list/start-process');
  };
  
  return (
    <>
      <Separator className="h-px bg-gray-200" />
      <div className="bg-white px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="text-sm text-gray-500">
          </div>
          
          <div className="flex items-center space-x-3">
            <Button 
              variant="outline" 
              onClick={handleCancel}
              disabled={isSubmitting}
            >
              <X className="w-4 h-4 mr-2" />
              Cancelar
            </Button>
            
            <Button 
              onClick={onSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <Spinner className="mr-2" />
              ) : (
                <Send className="w-4 h-4 mr-2" />
              )}
              {isSubmitting ? 'Iniciando...' : 'Iniciar Proceso'}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
